import { onetrust } from '../../../analyticsManager';
import { View, SortKeyCheck } from './combinedAnalyticsHelpers';
import {
  filterTrackingHelpers,
  selectedFilters,
  addFilter,
  removeFilter,
  clearCombinedAnalyticsFilterStore,
} from './filterTracking';
import metrics from './userMetrics';

const CombinedAnalytics = {
  // Our 2 basic actions and 1 advanced action.  Calls to additional or new analytics software can be made here.
  // Only the 2 basic actions need modifying for any given analytics software, just add their function calls for
  // identifying and tracking here.  It is assumed all analytics software on the market has these 2 basic calls,
  // so these are the two we are supporting going forward.  Even though syntax may vary, every analytics software
  // will have a track and identify method that you can call here.  All filterTrack does is re-arrange the filters
  // for readability.  At the end of it all it also will just call CombinedAnalytics.track.  No additional work
  // needs to be done to filterAnalytics when you add new analytics softare to this Context.
  actions: {
    identify: (props: any) => {
      // This is used to identify a unique user, across various platforms
      if (window.aptrinsic) {
        window.aptrinsic('identify', props);
      }
    },
    track: (name: string, props?: any) => {
      if (window.aptrinsic && onetrust.hasAnalyticsCookiesConsent()) {
        window.aptrinsic('track', name, props);
      }
    },
    // This is not a native aalytics event.  It's a helper method for the filters only
    filterTrack: (actions: any) => {
      const { filterCategory, filterName, filterValue, addToStore } = actions;

      if (addToStore) {
        // Store the selected filter. Selected filters will be consumed in another event in the application
        addFilter(`${filterCategory}.${filterName}`, filterValue);
      } else removeFilter(`${filterCategory}.${filterName}`);

      // Format for one property
      CombinedAnalytics.actions.track('filter_applied', {
        filter_category: `${filterCategory}`,
        filter_name: `${filterName}`,
        filter_value: `${filterValue}`,
      });
    },
  },
  helpers: {
    View,
    SortKeyCheck,
    selectedFilters,
    clearCombinedAnalyticsFilterStore,
    metrics,
  },
  filterTrackingHelpers,
};

export default CombinedAnalytics;
